'use client';

import React from 'react';

export function useRevealOnFirstScroll(active: boolean): boolean {
  const [revealed, setRevealed] = React.useState(false);
  const activeRef = React.useRef(active);
  activeRef.current = active;

  React.useEffect(() => {
    if (!active) {
      setRevealed(false);
      return;
    }
    if (typeof window !== 'undefined' && window.scrollY > 0) {
      setRevealed(true);
    }
  }, [active]);

  React.useEffect(() => {
    if (!active || revealed) {
      return undefined;
    }
    const onScroll = () => {
      if (activeRef.current) {
        setRevealed(true);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [active, revealed]);

  return active && revealed;
}
